import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    modalState: false,
    message: '',

    errorModalState: false,
    errorStatus: '',
    errorMessage: '',
    errorDetails: []
};

const modalSlice = createSlice({
    name: "modal",
    initialState: initialState,
    reducers: {
        setModal: (state, action) => {
            state.modalState = action.payload.state
            state.message = action.payload.message
        },

        setErrorModal: (state, action) => {
            state.errorMessage = action.payload.message
            state.errorStatus = action.payload.status
            state.errorModalState = action.payload.state
            state.errorDetails = action.payload.details
            state.url = action.payload.url
        },

        setInitialState: (state) => {
            return initialState
        }

    },
})

export const modalActions = modalSlice.actions

export default modalSlice.reducer